import { clsx } from 'clsx'


import { useEffect, useRef, useState } from 'react'
import axios from 'axios'

import NoiseSphere from './NoiseSphere';
import DemoCard, { DemoChecklistCard, DocSnippetCard, SummaryCard } from './DemoCard';
import HeroAnimation from './HeroAnimation';

// import img_elder from "../media/test/elder.png"



// const images = [
//   null, // abstract_image_0,
//   null, // abstract_image_1,
//   abstract_image_2,
//   null, // abstract_image_3,
//   null, // abstract_image_4
// ]

// const images = [
//   abstract_image_0,
//   abstract_image_1,
//   abstract_image_2,
//   abstract_image_3,
//   abstract_image_4
// ]

// const images_vertical = [
//   abstract_image_0,
//   abstract_image_1,
//   abstract_image_2,
//   abstract_image_3_vertical,
//   abstract_image_4
// ]






// export const AbstractOnly = ({
//   className,
//   background_version,
//   ...props
// }) => {

//   let version
//   switch (background_version) {
//     case 0:
//     case 1:
//     case 2:
//     case 3:
//     case 4: {
//       version = background_version

//       // Always break
//       break
//     }
//     case -1:
//     default: {
//       const n = 5 // 0 and 1
//       version = Math.floor(Math.random() * (n))
//       // const version = 0

//       // Always break
//       break
//     }
//   }

//   return (
//     <div
//       {...props}
//       className={clsx(
//         className,
//         // 'bg-[linear-gradient(115deg,var(--tw-gradient-stops))] from-[#fff1be] from-[28%] via-[#ee87cb] via-[70%] to-[#b060ff]',
//         // 'sm:bg-[linear-gradient(145deg,var(--tw-gradient-stops))]'
//       )}
//     >
//       <img
//         src={images_vertical[version]}
//         className={clsx(
//           "absolute md:hidden inset-0 w-full h-full object-cover"
//         )}
//       />
//       <img
//         src={images[version]}
//         className={clsx(
//           "hidden md:block absolute inset-0 w-full h-full object-cover"
//         )}
//       />
//     </div>
//   )
// }






const Background = ({
  leftFadeOffsetPx = -180,
  className,
  ...props
}: {
  leftFadeOffsetPx?: number
  className?: string
  blurBelowLg?: boolean
}) => {

  const [showDemo, setShowDemo] = useState<boolean | undefined>(undefined);
  const [phase, setPhase] = useState<"docs" | "trans" | "demo" | "dwell">("docs");
  const [orbPhase, setOrbPhase] = useState<"docs" | "trans" | "demo" | "dwell">("docs");
  const delayTimerRef = useRef<number | null>(null);
  const [jumpToken, setJumpToken] = useState<number>(0);
  const [jumpTo, setJumpTo] = useState<"docs" | "trans" | "demo" | "dwell">("demo");
  const leftFadeRef = useRef<HTMLDivElement | null>(null);
  // Unified stage height measured from visual viewport (single source of truth for CSS & JS)
  const getVisualViewportHeight = () => {
    if (typeof window !== "undefined" && (window as any).visualViewport && (window as any).visualViewport.height) {
      return Math.max(0, Math.floor((window as any).visualViewport.height));
    }
    return typeof window !== "undefined" ? window.innerHeight : 800;
  };
  const [stageH, setStageH] = useState<number>(getVisualViewportHeight());
  useEffect(() => {
    const handleResize = () => {
      // rAF to coalesce layout with CSS updates in the same frame
      requestAnimationFrame(() => setStageH(getVisualViewportHeight()));
    };
    const vv: any = typeof window !== "undefined" ? (window as any).visualViewport : null;
    vv?.addEventListener?.("resize", handleResize, { passive: true });
    window.addEventListener("resize", handleResize, { passive: true });
    window.addEventListener("orientationchange", handleResize, { passive: true });
    return () => {
      vv?.removeEventListener?.("resize", handleResize as any);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  useEffect(() => {

    
  }, []);
  
  // Dynamically position the left fade boundary just to the right of the hero text end
  useEffect(() => {
    const updateFade = () => {
      const hero = document.getElementById("hero-content");
      if (!hero || !leftFadeRef.current) return;
      const rect = hero.getBoundingClientRect();
      const offsetPx = leftFadeOffsetPx; // configurable per-page
      const linePx = Math.round(rect.right + offsetPx);
      // Wider band for a more seamless gradient on all sizes
      const bandPx = Math.round(Math.min(280, Math.max(120, window.innerWidth * 0.12)));
      leftFadeRef.current.style.setProperty("--left-fade-line-px", `${linePx}px`);
      leftFadeRef.current.style.setProperty("--left-fade-band-px", `${bandPx}px`);
    };
    updateFade();
    const ro = new ResizeObserver(updateFade);
    const hero = document.getElementById("hero-content");
    if (hero) ro.observe(hero);
    window.addEventListener("resize", updateFade);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", updateFade);
    };
  }, [leftFadeOffsetPx]);
  
  // Keep orb at high frequency (80) slightly longer when entering demo so cards fully exit the orb
  useEffect(() => {
    if (delayTimerRef.current) {
      clearTimeout(delayTimerRef.current);
      delayTimerRef.current = null;
    }
    if (phase === "demo") {
      // Match animation timings:
      // - Autoplay demo swoosh ramps ~600ms
      // - Click-controlled transition lasts ~800ms
      const delayMs = typeof showDemo === "boolean" ? 1500 : 1200;
      delayTimerRef.current = window.setTimeout(() => {
        setOrbPhase("demo");
        delayTimerRef.current = null;
      }, delayMs);
    } else {
      setOrbPhase(phase);
    }
    return () => {
      if (delayTimerRef.current) {
        clearTimeout(delayTimerRef.current);
        delayTimerRef.current = null;
      }
    };
  }, [phase, showDemo]);
  

  return (
    <div className={clsx("absolute inset-0 w-full h-full object-cover bg-[#0C101D]", className)}>

      {/* Constrain overlay and stage to site container width so they don't drift on ultra-wide screens */}
      <div className="absolute inset-0">
        <div className="mx-auto w-full h-full max-w-[min(88rem,calc(100%+16rem))] relative">

          {/* Graph overlay (base: full, no mask) */}
          <div className="absolute inset-0 pointer-events-none lg:hidden" aria-hidden="true">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  'linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)',
                backgroundSize: '20px 20px',
                backgroundPosition: '0 0',
              }}
            />
          </div>

          {/* Graph overlay (lg+: right half, masked on left) */}
          <div className="hidden lg:block absolute inset-y-0 right-0 w-1/2 pointer-events-none" aria-hidden="true">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  'linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)',
                backgroundSize: '20px 20px',
                backgroundPosition: '0 0',
                WebkitMaskImage: 'linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 20%, rgba(0,0,0,1) 100%)',
                maskImage: 'linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 20%, rgba(0,0,0,1) 100%)',
              }}
            />
            {/* Bottom fade */}
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  'linear-gradient(to bottom, rgba(12,16,28,0) 65%, rgba(12,16,28,1) 100%)',
              }}
            />
            {/* Top fade */}
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  'linear-gradient(to top, rgba(12,16,28,0) 65%, rgba(12,16,28,1) 100%)',
              }}
            />
            {/* Right fade */}
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  'linear-gradient(to right, rgba(12,16,28,0) 70%, rgba(12,16,28,1) 100%)',
              }}
            />
          </div>

          {/* Stage anchored relative to container width (stops at container max width) */}
          <div
            className={clsx(
                "absolute top-1/2 left-1/2 lg:left-[75%] -translate-x-1/2 -translate-y-1/2 transform"
            )}
          >
            {/* Optional blur below lg (used on demo page) */}
            <div className={clsx((props as any).blurBelowLg ? "blur-[5px] lg:blur-0" : "")}>
            {/* Large stage for layout (HeroAnimation fills this) */}
            <div
              className="relative w-[min(100%,1200px)]"
              style={{ height: `min(${stageH}px, 800px)` }}
            >

              {/* Orb centered within the stage */}
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
                  <div className="relative h-[240px] w-[240px]">
                  <NoiseSphere
                    version={0}
                    phase={orbPhase}
                    demo_is_active={!showDemo}
                    onClick={() => {
                      // Dynamic jump: docs/trans -> demo, demo -> dwell, dwell -> docs
                      setJumpTo(phase === "demo" ? "dwell" : phase === "dwell" ? "docs" : "demo");
                      setJumpToken((t) => t + 1);
                    }}
                  />
                </div>
              </div>

              {/* Animation overlay fills the stage, positioned relative to the same center */}
              <div className="absolute inset-0">
                <HeroAnimation
                  onPhaseChange={setPhase}
                  jumpTo={jumpTo}
                  jumpToken={jumpToken}
                  // Move the whole cluster up as stage height shrinks; baseline at 800px with 400px downward origin.
                  clusterTranslateY={-(400 - Math.max(0, 400 - Math.max(0, 800 - stageH) * 0.5))}
                />
              </div>

              </div>
            </div>
          </div>

        </div>
      </div>
      
      {/* Global fades to soften edges; base: full-viewport vignettes; lg+: hero-text left fade + bottom */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        {/* Base-only four-edge fades */}
        <div className="absolute inset-0 lg:hidden">
          {/* Top */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'linear-gradient(to top, rgba(12,16,28,0) 60%, rgba(12,16,28,1) 100%)',
            }}
          />
          {/* Bottom */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'linear-gradient(to bottom, rgba(12,16,28,0) 60%, rgba(12,16,28,1) 100%)',
            }}
          />
          {/* Left */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'linear-gradient(to left, rgba(12,16,28,0) 60%, rgba(12,16,28,1) 100%)',
            }}
          />
          {/* Right */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'linear-gradient(to right, rgba(12,16,28,0) 60%, rgba(12,16,28,1) 100%)',
            }}
          />
        </div>
        {/* lg+: left fade aligned to hero text */}
        <div
          className="hidden lg:block absolute inset-0"
          ref={leftFadeRef}
          style={{
            backgroundImage:
              'linear-gradient(90deg, rgba(12,16,28,1) 0px, rgba(12,16,28,1) calc(var(--left-fade-line-px) - var(--left-fade-band-px)), rgba(12,16,28,0) var(--left-fade-line-px), rgba(12,16,28,0) 100%)',
          } as React.CSSProperties}
        />
        {/* Bottom fade across all sizes */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(to bottom, rgba(12,16,28,0) 66%, rgba(12,16,28,1) 100%)',
          }}
        />
      </div>
      

    </div>
  )
}



export default Background;

